module.exports = __webpack_public_path__ + "static/media/MT.6752aa90.png";